import axios from 'axios';

export default function searchUser(cohort, q) {
  return axios.get('/api/v1/lwadmin/users/_search', { params: { cohort, q } });
}
